/**
 * EventDispatcher,包含静态对象eventCenter
 * @author chengxiao
 * @class
 * @package base
 */
 
const listenersKey = '__listeners';

class EventDispatcher {
    constructor() {
        this[ listenersKey ] = {};
        //  throw new Error('sssss')
    }

    
    /**
     * 派发事件
     * @param {string} name 事件名
     * @param {Object=} e 发送的[事件对象$Event]
     */
    dispatchEvent(name, e) {

        var _handlers = this[listenersKey][name];
        if(!_handlers || !_handlers.length) {
            return false;
        }
        e = e || {};
        if (!e.type)
            e.type = name;
        if (!e.target)
            e.target = this;
        var args = [], handler;
        for (var i = 0, l = _handlers.length; i < l; i++) {
            handler = _handlers[i];
//            args = handler.args.slice(0);
            args.unshift(e);
            handler.fn.apply(handler.owner, args);
        }
        return true;
    }

    /**
     * 批量注册事件
     * @param {Object} handler
     * @param {Object} context
     */
    addEventListeners(handler, context) {
        if ( typeof handler == "object") {
            for (var f in handler) {
                if ( handler.hasOwnProperty( f ) ) {// !
                    this.addEventListener(f, handler[f], context);
                }
            }
        }
        return this;
    }
    
    /**
     * 绑定事件
     * 
     */
    addEventListener(sEventName, fListener, context) {
        
        if( 'function' !== typeof fListener ) {
            return ;
        }
        
        context = context || this;
        this[listenersKey] = this[listenersKey] || {};
        var listeners = this[listenersKey];

        if ( !listeners[sEventName] ) {
            listeners[sEventName] = [];
        }

        listeners[sEventName].push({
            fn : fListener,
            owner : context
        });

        return this;
    }

    removeEventListener(sEventName, fListener) {
        var _ea = this[listenersKey][sEventName];
        if(typeof fListener !== 'function') {
            this[listenersKey][sEventName] = [];
            return this;
        }
        for (var i = 0; i < _ea.length; i++) {
            if (_ea[i].fn === fListener) {
                _ea.splice(i--, 1);
            }
        }
        return this;
    }

    removeEventListeners(listener) {
        if(listener && typeof listener === 'object') {
            for(var p in listener) {
                this.removeEventListener(p, listener[p]);
            }
        } else {
            this[listenersKey] = {};
        }
    }
}
//////////////////////////////

var eventCenter = new EventDispatcher;

// 内置一个消息中心
EventDispatcher.eventCenter = eventCenter;

/////////////////////////////////
export default EventDispatcher;

